import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  CardContent,
  Grid,
  Divider,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
} from "@material-ui/core";
import { HeadQuarterRoute } from "../../head-quarter.routes";
import TabHeader from "src/components/TabHeader/TabHeader";
import { CheckSharp, ExpandMore } from "@material-ui/icons";
import CommonButton from "src/components/CommonButton/CommonButton";
import { ISettingsSection } from "src/common/typings/hq-dashboard";
import moment from "moment";
import { useFormik } from "formik";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { Revenue } from "./components/Revenue";
import { Vehicles } from "./components/Vehicles";
import { Cargo } from "./components/Cargo";
import { Yard } from "./components/Yard";
import { useStyles } from "./components/style";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  loader,
  setEndDate,
  setSelectedBorderTerminalValues,
  setStartDate,
} from "src/app-redux/hq-dashboard/hqDashboardSlice";
import CommonSelectMultiple from "src/components/molecules/CommonSelectMultiple";
import { SelectChangeEvent } from "@mui/material";
import { getAllTerminals } from "src/app-redux/hq-dashboard/actions/hqDashboardActions";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export default function Insights({}: Props): React.ReactElement {
  const classes = useStyles();
  const moduleName = HeadQuarterRoute.title;
  const pageHeading = "Insights";
  const [sortedTabs, setTabsSorting] = useState<ISettingsSection[]>([]);
  const [expandRevenue, setExpandRevenue] = React.useState<boolean>(true);
  const [expandVehicle, setExpandVehicle] = React.useState<boolean>(true);
  const [expandCargo, setExpandCargo] = React.useState<boolean>(true);
  const [expandYard, setExpandYard] = React.useState<boolean>(true);
  const date = new Date();
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const loading = useAppSelector(loader);
  const dispatch = useAppDispatch();
  const [borderTerminalArr, setBorderTerminalArr] = useState<any[]>([]);
  const [selectedBorderTerminals, setSelectedBorderTerminals] = useState<string[]>([]);

  const formik = useFormik({
    initialValues: {
      terminalId: [2],
      filterBy: "lastMonth",
      startDate: moment(
        new Date(new Date().setDate(new Date().getDate() - 29)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm"),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      startDateCustom: moment(new Date().setDate(date.getDate())).format("YYYY-MM-DD"),
      endDateCustom: moment(new Date().setDate(date.getDate())).format("YYYY-MM-DD"),
      showRevenue: true,
      showVehicles: true,
      showCargo: true,
      showYard: true,
    },
    onSubmit: (values) => {
      // handleSearch();
    },
  });
  const { values, setValues } = formik;

  useEffect(() => {
    dispatch(setStartDate(formik.values.startDate));
    dispatch(setEndDate(formik.values.endDate));
  }, [formik.values.startDate, formik.values.endDate]);

  useEffect(() => {
    getTerminals();
    getSettings();
  }, []);

  const getTerminals = async () => {
    const res: any = await dispatch(getAllTerminals());
    if (res?.payload?.borderTerminals?.length) {
      setBorderTerminalArr(res?.payload?.borderTerminals);
      const selectedId: any = [];
      const selectedName: any = [];
      res?.payload?.borderTerminals.forEach((item: any) => {
        selectedId.push(item.id);
        selectedName.push(item.name);
      });
      setSelectedBorderTerminals(selectedName);
      dispatch(setSelectedBorderTerminalValues(selectedId));
      formik.setFieldValue("terminalId", selectedId);
    }
  };

  const getSettings = async () => {
    setTabsSorting([
      { name: "vehicle", sortOrder: 1, visibility: true },
      { name: "cargo", sortOrder: 2, visibility: true },
      { name: "revenue", sortOrder: 3, visibility: true },
      { name: "yard", sortOrder: 4, visibility: true },
    ]);
  };

  const filterByAction = (data: any) => {
    if (data && data.value) {
      const td = new Date();
      const now = moment(new Date(new Date().setDate(td.getDate()))).format("YYYY-MM-DDTHH:mm");
      const todayStart = moment(new Date(new Date().setDate(td.getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      );
      const todayEnd = moment(new Date(new Date().setDate(td.getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      );
      const yesterdayStart = moment(
        new Date(new Date().setDate(td.getDate() - 1)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm");
      const yesterdayEnd = moment(
        new Date(new Date().setDate(td.getDate() - 1)).setHours(23, 59)
      ).format("YYYY-MM-DDTHH:mm");
      const lastWeek = moment(new Date(new Date().setDate(td.getDate() - 6)).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      );
      const lastMonth = moment(
        new Date(new Date().setDate(td.getDate() - 29)).setHours(0, 0)
      ).format("YYYY-MM-DDTHH:mm");

      if (data.value === "today") {
        formik.setFieldValue("filterBy", "today");
        formik.setFieldValue("startDate", todayStart);
        formik.setFieldValue("endDate", todayEnd);
      }
      if (data.value === "yesterday") {
        formik.setFieldValue("filterBy", "yesterday");
        formik.setFieldValue("startDate", yesterdayStart);
        formik.setFieldValue("endDate", yesterdayEnd);
      }

      if (data.value === "lastWeek") {
        formik.setFieldValue("startDate", lastWeek);
        formik.setFieldValue("endDate", todayEnd);
      }
      if (data.value === "lastMonth") {
        formik.setFieldValue("startDate", lastMonth);
        formik.setFieldValue("endDate", todayEnd);
      }
      if (
        data.value === "today" ||
        data.value === "yesterday" ||
        data.value === "lastWeek" ||
        data.value === "lastMonth"
      ) {
        setIsCustomDate(false);
      }
      if (data.value === "custom") {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", todayStart);
        formik.setFieldValue("endDateCustom", now);
      }
    }
  };
  const filterByArr = [
    { label: "Today", value: "today" },
    { label: "Yesterday", value: "yesterday" },
    { label: "Last 7 days", value: "lastWeek" },
    { label: "Last 30 days", value: "lastMonth" },
    { label: "Custom", value: "custom" },
  ];

  const handleChange =
    (panel: string) => (event: React.ChangeEvent<unknown>, newExpanded: boolean) => {
      if (panel === "revenue") {
        setExpandRevenue(newExpanded);
      } else if (panel === "vehicle") {
        setExpandVehicle(newExpanded);
      } else if (panel === "cargo") {
        setExpandCargo(newExpanded);
      } else if (panel === "yard") {
        setExpandYard(newExpanded);
      }
    };

  const handleMultiselectChange = (event: SelectChangeEvent<any>) => {
    const {
      target: { value },
    } = event;
    setSelectedBorderTerminals(value);
    const selected = value.map((name: any) => {
      return borderTerminalArr.find((item: any) => item.name === name)?.id;
    });
    dispatch(setSelectedBorderTerminalValues(selected));
    formik.setFieldValue("terminalId", selected);
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CommonLoader />
      </Backdrop>
      <TabHeader module={moduleName} heading={pageHeading} />
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain} style={{ height: "100%" }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={8}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}>{pageHeading}</Typography>
              </Box>
            </Grid>
          </Grid>
          <Divider />
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            style={{ paddingTop: "10px" }}
          >
            <Grid item container direction="row" xs={12} md={7} lg={5}>
              <Grid item xs={12} md={5}>
                <CommonSelectMultiple
                  cssClassName={
                    selectedBorderTerminals.length ? "customTextFieldUnselected" : "customTextField"
                  }
                  inputLabel="Select Border Terminal"
                  name="terminalId"
                  allValues={borderTerminalArr}
                  value={selectedBorderTerminals}
                  onChange={handleMultiselectChange}
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <Box
                  sx={{ marginLeft: { xs: "0", md: "10px" }, marginTop: { xs: "10px", md: "0" } }}
                >
                  <CommonAutoCompleteField
                    error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                    helperText={formik.touched.filterBy && formik.errors.filterBy}
                    label="Filter By"
                    placeholder="Filter By"
                    name="filterBy"
                    optionsType={filterByArr}
                    getOptionLabel={(option: any) => option.label || null}
                    onChange={(row: any) => {
                      row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                      if (row === null) {
                        formik.setFieldValue("filterBy", null);
                      }
                      filterByAction(row);
                    }}
                    value={
                      filterByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                    }
                  />
                </Box>
              </Grid>
              <Grid item xs={12} container direction="row" style={{ marginTop: "12px" }}>
                <Grid item xs={12} container direction="row">
                  <Grid item xs={12} md={5} lg={5}>
                    <Box className={!isCustomDate ? classes.hideDatesGrid : ""}>
                      <CommonTextFieldDate
                        label={"Start Date"}
                        name={"startDateCustom"}
                        value={formik.values.startDateCustom}
                        onChange={(e: any) => {
                          formik.setFieldValue(
                            "startDateCustom",
                            moment(e).format("YYYY-MM-DDTHH:mm")
                          );
                          formik.setFieldValue("endDateCustom", "");
                        }}
                        maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={5} lg={5}>
                    <Box
                      className={!isCustomDate ? classes.hideDatesGrid : ""}
                      sx={{
                        marginLeft: { xs: "0", md: "10px" },
                        marginTop: { xs: "10px", md: "0" },
                      }}
                    >
                      <CommonTextFieldDate
                        label={"End Date"}
                        name={"endDateCustom"}
                        value={formik.values.endDateCustom}
                        onChange={(e: any) => {
                          formik.setFieldValue(
                            "endDateCustom",
                            moment(e).format("YYYY-MM-DDTHH:mm")
                          );
                        }}
                        minDate={formik.values.startDateCustom}
                        maxDate={moment().format("YYYY-MM-DDTHH:mm")}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={2} lg={2}>
                    <Box
                      className={!isCustomDate ? classes.hideDatesGrid : ""}
                      sx={{
                        margin: { xs: "10px 0px 10px 0", md: "0" },
                        marginLeft: { xs: "0", md: "10px" },
                      }}
                    >
                      <CommonButton
                        isGreen
                        cssClass={classes.checkButton}
                        onClick={() => {
                          formik.setFieldValue("startDate", formik.values.startDateCustom);
                          formik.setFieldValue("endDate", formik.values.endDateCustom);
                        }}
                      >
                        <CheckSharp />
                      </CommonButton>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={7}></Grid>
          </Grid>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={12}>
              <div>
                {sortedTabs.map((item: any) => {
                  return item.name === "revenue" && item.visibility ? (
                    <Accordion
                      elevation={0}
                      key={item.name}
                      expanded={expandRevenue}
                      onChange={handleChange("revenue")}
                    >
                      <AccordionSummary
                        aria-controls="panel1d-content"
                        id="panel1d-header"
                        className={classes.tabRow}
                        expandIcon={<ExpandMore className={classes.tabIcon} />}
                      >
                        <Grid container direction="row">
                          <Grid item md={9}>
                            <Typography
                              style={{
                                marginLeft: "10px",
                                fontSize: "14px",
                                fontWeight: 700,
                              }}
                            >
                              Revenue
                            </Typography>
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Revenue />
                      </AccordionDetails>
                    </Accordion>
                  ) : item.name === "vehicle" && item.visibility ? (
                    <Accordion
                      elevation={0}
                      key={item.name}
                      expanded={expandVehicle}
                      onChange={handleChange("vehicle")}
                    >
                      <AccordionSummary
                        aria-controls="panel2d-content"
                        id="panel2d-header"
                        className={classes.tabRow}
                        expandIcon={<ExpandMore className={classes.tabIcon} />}
                      >
                        <Grid container direction="row">
                          <Grid item md={9}>
                            <Typography
                              style={{
                                marginLeft: "10px",
                                fontSize: "14px",
                                fontWeight: 700,
                              }}
                            >
                              Vehicles
                            </Typography>
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Vehicles />
                      </AccordionDetails>
                    </Accordion>
                  ) : item.name === "cargo" && item.visibility ? (
                    <Accordion
                      elevation={0}
                      key={item.name}
                      expanded={expandCargo}
                      onChange={handleChange("cargo")}
                    >
                      <AccordionSummary
                        aria-controls="panel3d-content"
                        id="panel3d-header"
                        className={classes.tabRow}
                        expandIcon={<ExpandMore className={classes.tabIcon} />}
                      >
                        <Grid container direction="row">
                          <Grid item md={9}>
                            <Typography
                              style={{
                                marginLeft: "10px",
                                fontSize: "14px",
                                fontWeight: 700,
                              }}
                            >
                              Cargo
                            </Typography>
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Cargo />
                      </AccordionDetails>
                    </Accordion>
                  ) : item.name === "yard" && item.visibility ? (
                    <Accordion
                      elevation={0}
                      key={item.name}
                      expanded={expandYard}
                      onChange={handleChange("yard")}
                    >
                      <AccordionSummary
                        aria-controls="panel3d-content"
                        id="panel3d-header"
                        className={classes.tabRow}
                        expandIcon={<ExpandMore className={classes.tabIcon} />}
                      >
                        <Grid container direction="row">
                          <Grid item md={9}>
                            <Typography
                              style={{
                                marginLeft: "10px",
                                fontSize: "14px",
                                fontWeight: 700,
                              }}
                            >
                              Yard Management
                            </Typography>
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Yard />
                      </AccordionDetails>
                    </Accordion>
                  ) : (
                    ""
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}
